import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../api/services/user.service';
import { Organization, PaginatedOrganizationDTO  } from '../../../api/models/organization';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { AuthService } from '../../../api/services/auth.service';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { Subject } from 'rxjs/Subject';
import { PreferencesService } from '../../../api/services/preferences.service';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {

  constructor(
    private userService: UserService,
    private modalService: NgbModal,
    private authService: AuthService,
    private toastr: ToastrService,
    private preferencesService: PreferencesService
  ) {
    this.searchSubject.asObservable()
      .debounceTime(1000)
      .subscribe(orgSearchText => {
        if (orgSearchText) {
          this.orgSearchText = orgSearchText;
        }
        this.loadPage(1);
      });
  }

  totalRecords = 0;
  sorting: string = "name,asc";
  paginatedRequest: PaginatedRequest;
  orgList: PaginatedOrganizationDTO;
  organizations: Organization[] = [];
  orgSearchText: string = "";
  searchSubject: Subject<string> = new Subject<string>();
  page = 1;
  pageSize = 50;
  loading = false;
  edit = false;
  clientSelected: Organization;
  visibleContext = false;
  infoMsg = ['No records found!'];

  canEdit = false;
  canDelete = false;

  delete(item) {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    //modalRef.componentInstance.id = item['Organization ID'];
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the client <strong>${item['Name']}</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.userService.removeOrganization(item['Organization ID']).subscribe(() => {
        modalRef.close();
        this.onUpdateSuccess();
        this.loadPage(this.page);
      });
    };
  }

  private onUpdateSuccess() {
    this.toastr.success('Client deleted!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  loadPage(page) {
    this.loading = true;
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.userService.getOrganizationsForListing(this.paginatedRequest, this.orgSearchText).subscribe(items => {
      this.loading = false;
      this.orgList = items;
      if (this.orgList.totalRecords && this.orgList.totalRecords > 0) {
        this.totalRecords = this.orgList.totalRecords;
        this.organizations = this.orgList.records;
      } else {
        this.totalRecords = 0;
        this.organizations = [];
      }
    });
  }

  searchClient(value) {
    this.page = 1;
    if (value) {
      this.orgSearchText = value;
      this.searchSubject.next(value);
    } else {
      this.orgSearchText = "";
      this.loadPage(this.page);
    }
  }

  editClient(client: Organization) {
    this.clientSelected = client;
    this.edit = true;
  }

  createClient() {
    this.clientSelected = new Organization();
    this.edit = true;
  }

  backToListing() {
    this.edit = false;
    this.orgSearchText = "";
    this.loadPage(this.page);
  }

  ngOnInit() {
    this.calculateRequiredPermissions();
    this.loadPage(this.page);
  }

  calculateRequiredPermissions() {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      const context = `ORGANIZATION~${user['Organization ID']}`;
      let roleRequest = new RoleRequest('ORGANIZATION_CREATE', context);
      roleRequest.setRoleAndContextMap('ORGANIZATION_UPDATE', context);
      roleRequest.setRoleAndContextMap('ORGANIZATION_DELETE', context);
      
      this.authService.getUserRoles(roleRequest).subscribe(roles => {
        this.visibleContext = roles.getRoleMap('ORGANIZATION_CREATE');
        this.canEdit = roles.getRoleMap('ORGANIZATION_UPDATE');
        this.canDelete = roles.getRoleMap('ORGANIZATION_DELETE');
      });
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/client-list/client-list.component.ts